<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="110px" size="mini">
          <el-form-item label="订单编号" prop="orderNo">
            <el-input class="form-input" v-model="searchForm.orderNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单状态" prop="signupStatus">
            <el-select v-model="searchForm.signupStatus" clearable @change="onSearch">
              <el-option v-for="item in cusStatusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建订单时间">
            <q-date-picker 
              startFiled="buyTimeStart" 
              endFiled="buyTimeEnd" 
              v-model="searchForm" 
              :isDefault="false"
              ref="dateRef"
            />
          </el-form-item>
          <el-form-item label="退款时间">
            <q-date-picker 
              startFiled="refundTimeStart" 
              endFiled="refundTimeEnd" 
              v-model="searchForm" 
              :isDefault="false"
              ref="refundRef"
            />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="exportFile">
          导出
        </el-button>
      </template>
      <el-table stripe v-loading="loading" ref="tableRef" highlight-current-row :data="tableData" border :height="maxTableHeight">
        <el-table-column prop="orderNo" label="订单号" align="center" width="280" show-overflow-tooltip></el-table-column>
        <el-table-column prop="merNo" label="银联商户号"  width="150" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="buyTime" label="创建订单时间" align="center" show-overflow-tooltip width="160"></el-table-column>
        <el-table-column prop="userName" label="用户名" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userPhone" label="联系方式" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="activityId" label="活动ID" width="70"></el-table-column>
        <el-table-column prop="settlementAmount" label="金额" width="70" show-overflow-tooltip></el-table-column>
        <el-table-column prop="signupStatus" label="状态" width="70" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.signupStatus | signupStatusStr  }}
          </template>
        </el-table-column>
        <el-table-column prop="orgName" label="区域" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName" label="经销商" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeName" label="分享门店" show-overflow-tooltip></el-table-column>
        <el-table-column prop="refundTime" label="退款时间" width="160" show-overflow-tooltip></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from 'moment';
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {},
  data() {
    return {
      searchForm: {
        orderNo: "",
        signupStatus: "",
        buyTimeEnd: "",
        buyTimeStart: "",
        refundTimeStart: "",
        refundTimeEnd: ""
      },
      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      cusStatusList: [
        { value: "",  label: "全部" },
        { value: "1", label: "已报名" },
        { value: "2", label: "已核销" },
        { value: "3", label: "已退款" },
        { value: "6", label: "退款中" },
        { value: "7", label: "待退款" },
        { value: "9", label: "已线下退款" },
      ],
    };
  },

  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          customerId: this.$route.query.customerId
        },
      };
      this.$api.dataReport
        .checkCustomerUnionOrderDtl(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {
        createUserId: this.$route.query.userId || "",
      };
      let map = ['buyTimeStart', 'buyTimeEnd', 'refundTimeStart', 'refundTimeEnd']
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (map.includes(key) && val) {
          this.filterParam[key] = moment(val).format('YYYYMMDD');
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.buyTimeStart = ''
      this.searchForm.buyTimeEnd = ''
      this.searchForm.refundTimeStart = ''
      this.searchForm.refundTimeEnd = ''
      this.$refs.dateRef.reset()
      this.$refs.refundRef.reset()
    },
    exportFile() {
      let params = {
        ...this.filterParam,
        customerId: this.$route.query.customerId
      };
      this.$api.common.doExport("checkCustomerUnionOrderDtl", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  filters: {
    signupStatusStr(status) {
      let map = {
        1: '已报名',
        2: "已核销",
        3: "已退款",
        6: "退款中",
        7: "待退款",
        9: "已线下退款",
       }
       return map[status]
    }
  },
  mounted() {
    let query = this.$route.query;
    this.searchForm.reconciliationId = query.id || "";
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.date-input
  width 220px !important
.content
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  flex-direction column
  .or-code
    width 140px
    height 140px
    margin-top 20px
</style>
